class NotSupported extends Error {
  constructor (message = '', ...args) {
    super(message, ...args)
    this.message = message + ' is not supported.'
  }
}

class DuplicateLocale extends Error {}

export { NotSupported, DuplicateLocale }
